import React from 'react';

import amplitude from 'amplitude-js';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { INCREASE_LIMITS_CONTINUE_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { GT_LEVEL } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { AUTH_PROFILE_AML_LEVEL, AUTH_PROFILE_AML_LEVELS, AUTH_PROFILE_LIMITS } from 'apps/auth/constants/UrlConstants';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';
import { UsaService } from 'apps/auth/services/UsaService';

export const ProfileAmlLevelInfo = ({ insideModalComponent = false, onClickNotNow, onClickContinue }) => {
    const { profilePurpleBlock, aml_level_name, increase_block, increase_sub_block, notNowButton, nextButton } = usePageMessages();
    const { current_limit, profile_form: profile } = useExtra();

    const newUsaLimits = UsaService.isNewLimits(profile);
    const iconName = newUsaLimits ? 'id-card-80' : 'zap-80';
    const notNowHref = newUsaLimits ? AUTH_PROFILE_LIMITS : AUTH_PROFILE_AML_LEVELS;
    const expectedGTLevel = current_limit + 1;

    return (
        <InfoPage
            insideModalComponent={insideModalComponent}
            iconName={iconName}
            iconColor="primary"
            headerText={
                <>
                    <span className="color-GT">{resolveArguments(profilePurpleBlock, aml_level_name)}</span>&nbsp;
                    {increase_block}
                </>
            }
            secondaryText={<DangerouslyHtml dangerouslyHtml={increase_sub_block} />}
            topButtonCaption={notNowButton}
            topButtonType="link"
            topButtonLink={notNowHref}
            topButtonOnClick={(e) => {
                if (onClickNotNow) {
                    e.preventDefault();
                    onClickNotNow();
                }
            }}
            primaryButtonCaption={nextButton}
            primaryButtonType="link"
            primaryButtonLink={`${AUTH_PROFILE_AML_LEVEL}/${current_limit}/docs`}
            primaryButtonOnClick={(e) => {
                expectedGTLevel ? amplitude.getInstance().logEvent(INCREASE_LIMITS_CONTINUE_CLICKED, { [GT_LEVEL]: expectedGTLevel }) : null;
                if (onClickContinue) {
                    e.preventDefault();
                    onClickContinue();
                }
            }}
        />
    );
};
